import mixpanel from 'mixpanel-browser/src/loaders/loader-module-core';
import { initPendo } from '../../pendo';

/* global pendo */

let initialized = false;

let mixpanelDisabled = false;
let pendoDisabled = false;

function callPendoInitialize(userInfoData, workgroupName) {
    setTimeout(() => {
        pendo.initialize({
            visitor: {
                id: `${userInfoData.id}@${workgroupName}`,
                marketplace_admin: !!userInfoData.isAdmin,
                marketplace_domain: userInfoData.domain,
                marketplace_tenant: userInfoData.tenantId,
            },
            account: {
                id: workgroupName,
            },
        });
    }, 10000);
}

export function initialize(userInfoData) {
    const { tracking } = userInfoData;
    const workgroupName = userInfoData.domain.split('.')[0];

    if (!tracking.disableMixpanel) {
        mixpanel.init(userInfoData.mixPanelKey);
        mixpanel.identify(`${userInfoData.id}.${userInfoData.domain}`);
        mixpanel.register({
            admin: !!userInfoData.isAdmin,
            domain: userInfoData.domain,
            tenant: userInfoData.tenantId,
        });
    } else {
        mixpanelDisabled = true;
    }

    if (tracking.disablePendo) {
        pendoDisabled = true;
    }

    if (window.pendo && !tracking.disablePendo) {
        initPendo();

        callPendoInitialize(userInfoData, workgroupName);
    }

    initialized = true;
}

export function ready() {
    let waitForPendo = false;
    if (window.pendo && !window.pendo.track) {
        waitForPendo = true;
    }

    return initialized && !waitForPendo;
}

export function track(eventName, data) {
    if (!mixpanelDisabled) {
        mixpanel.track(eventName, data);
    }

    if (window.pendo && !pendoDisabled) {
        pendo.track(eventName, data);
    }
}
